export default __webpack_public_path__ + "static/media/city.f07b486b.svg";